import React from 'react';
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from '@directv-digital/dds.ui.dtv-box';
import DtvText, { IDtvTextProps } from '@directv-digital/dds.ui.dtv-text';
import Tooltip from "@directv-digital/fusion.molecules.tooltip";
import { pkgStyles, channelColWidthStyle, channelLabelColWidthStyle } from '../PackageCmprGrid.styles';
import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

interface ChannelRowProps {
    packagesList?: any[];
    index?: number;
    id?: string;
    channelDetails?: {
        teamNames?: string;
        rsnTierLegal?: string;
        indicatorLabels?: string[];
    };
    mainColWidthStyle?: React.CSSProperties;
    name?: string;
    icon?: string;
    indicators: any[];
    packageId?: string;
    category?: string;
    myfreeDtvDescription?: IDtvTextProps;
    subscription?: boolean;
    getFixedCol?: any;
}

export const ChannelRow = (props: ChannelRowProps) => {
  try {
    const {
      getFixedCol, index, channelDetails, name,
      indicators, packageId, category, myfreeDtvDescription, subscription
    } = props;
    return (
            <DtvBox>
                {packageId === "MYFREE_DTV" && index === 0 && <DtvBox
                    sx={{
                        ...pkgStyles?.myfreeDtvDescriptionContainer
                    }}
                >
                <DtvText content={myfreeDtvDescription?.content}
                    sx={{
                        ...pkgStyles?.myfreeDtvDescriptionText
                    }}
                />
                </DtvBox>}
                <DtvBox
                    id={`ChannelRow-${name}-${index}`}
                    key={`ChannelRow-${name}-${index}`}
                    sx={{
                        ...pkgStyles?.channelRow
                    }}
                >
                    <DtvBox
                        sx={{
                            ...channelLabelColWidthStyle,
                            ...pkgStyles?.channelNameContainer,
                            ...pkgStyles?.channelNameData,
                            width: {
 xs: "105px",
sm: "175px",
md: "255px"
},
                            minWidth: {
 xs: "105px",
sm: "175px",
md: "255px"
},
                            ...(packageId === "MYFREE_DTV" ? pkgStyles?.channelNameMyfreeDtv : {}),
                            ...(subscription || ["local", "rsn", "national"].includes(category?.toLowerCase?.())) && {
                                ...(subscription && { padding: "20px 0px!important" }),
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px"
                            },
                            ...getFixedCol,
                            borderTop: index === 0 ? `1px solid ${colorPalette.neutral[400]}` : "none",
                            borderLeft: `1px solid ${colorPalette.neutral[400]}`
                        }}
                    >
                        <DtvText
                            content={name}
                            variant={"body3medium"}
                            sx={{
                                fontSize: "14px !important",
                                fontWeight: 500,
                                lineHeight: "130%",
                                ...(subscription && { padding: "0px 8px" })
                            }}
                        />
                        {["local", "rsn", "national"].includes(category?.toLowerCase?.()) && (
                            <DtvText
                                content={category}
                                variant="smalltext"
                                sx={{
                                    ...pkgStyles?.localRsnLabel
                                }}
                            />
                        )}
                    </DtvBox>
                    {packageId !== "MYFREE_DTV" && indicators.map((val, ind) => {
                        const tooltipLabel = channelDetails?.indicatorLabels?.[ind] || "";
                        return (
                            <DtvBox
                                id={`channelrow-box-${index}-${ind}`}
                                key={`channelrow-box-${index}-${ind}`}
                                sx={{
                                    ...channelColWidthStyle,
                                    ...pkgStyles?.channelIndicatorBox,
                                    borderRight: `1px solid ${colorPalette.neutral[400]}`,
                                    borderTop: index === 0 ? `1px solid ${colorPalette.neutral[400]}` : "none"
                                }}
                            >
                                {(val === 1) && (
                                    <Tooltip
                                        content={tooltipLabel}
                                        fontSize="16px"
                                        placement={"top"}
                                        title="Included in"
                                        PopperProps={{
                                            sx: {
                                                width: "fit-content !important",
                                                "& .MuiTypography-root": {
                                                    fontFamily: "PFDinReg, PFDinMed, sans-serif, roboto",
                                                    fontWeight: 400,
                                                    fontSize: "16px !important"
                                                },
                                                "& .MuiTooltip-tooltip .MuiTypography-root:first-of-type": {
                                                    paddingBottom: "4px !important"
                                                }
                                            }
                                        }}
                                        tooltipStyles={{
                                            textAlign: "center",
                                            color: "#102641",
                                            backgroundColor: "#fff",
                                            borderRadius: 4,
                                            padding: "8px 16px",
                                            width: "auto",
                                            minWidth: 0,
                                            maxWidth: 220,
                                            lineHeight: 1.2,
                                            boxShadow: "0 2px 20px 0 rgba(0,0,0,0.16)"
                                        }}
                                    >
                                        <img
                                            alt={`Included in ${tooltipLabel}`}
                                            src="https://www.directv.com/dtvassets/global/icons/component-controls/icons-in-table_check.svg"
                                            style={{
                                                width: "24px",
                                                height: "24px",
                                                verticalAlign: "middle",
                                                display: "inline-flex"
                                            }}
                                        />
                                    </Tooltip>
                                )}
                                {category === "channelCount" && (
                                    <DtvText
                                        content={val || ""}
                                        sx={{
                                            color: colorPalette.blue[900],
                                            fontSize: "14px !important",
                                            fontWeight: 500,
                                            textAlign: "left"
                                        }}
                                    />
                                )}
                            </DtvBox>
                        )
                    })}
                </DtvBox>
                {category?.toLowerCase?.() === "rsn" && <DtvBox>
                    {channelDetails?.teamNames && <DtvBox sx={{
 display: "flex",
width: "100%",
backgroundColor: colorPalette.gray[300],
padding: "4px 20px 4px 20px",
gap: "10px",
color: colorPalette.neutral_white.main
}}>
                        <DtvText content="Teams: " variant="body3medium" />
                        <DtvText content={channelDetails?.teamNames || ''} variant="body3" />
                    </DtvBox>}
                    {channelDetails?.rsnTierLegal && <DtvBox sx={{
 backgroundColor: colorPalette.neutral[100],
padding: "4px 20px 4px 20px"
}}>
                        <DtvText
                            content={channelDetails?.rsnTierLegal || ''}
                            sx={{
 fontSize: "12px !important",
color: colorPalette.jet.main
}}
                        />
                    </DtvBox>}
                </DtvBox>}
            </DtvBox>
    );
  } catch (error) {
    console.error("Error in Customer Acq Compare Tool - channelrow >> ", error);
    return <ErrorDisplay component="Customer Acq Compare Tool -> channelrow" error={error}/>;
  }
}
